export   function header_footer_get_parameters() {
let DEFAULT_SITE ='kay'   
let availableEnv = {
    'localhost': ['localhost', 'dev1', 'dev2', 'dev3', 'dev4',
        'qa1', 'qa2', 'uat1', 'uat2', 'perf1', 'perf2',],
    'zales': ['personalized.', 'dev1', 'dev2', 'dev3', 'dev4',
        'qa1', 'qa2', 'uat1', 'uat2', 'perf1', 'test',],
    'gordonsjewelers': ['personalized.', 'dev1', 'dev2', 'dev3', 'dev4',
        'qa1', 'qa2', 'uat1', 'uat2', 'perf1', 'perf2',],
    'peoplesjewellers': ['personalized.', 'dev1', 'dev2', 'dev3', 'dev4',
        'qa1', 'qa2', 'uat1', 'uat2', 'perf1', 'perf2',],
    'zalesoutlet': ['personalized.', 'dev1', 'dev2', 'dev3', 'dev4',
        'qa1', 'qa2', 'uat1', 'uat2', 'perf1', 'perf2',],
    'pagoda': ['personalized.', 'dev1', 'dev2', 'dev3', 'dev4',
        'qa1', 'qa2', 'uat1', 'uat2', 'perf1', 'perf2',],
    'kayoutlet': ['prod2','personalized.', 'www','dev1','uat1', 'uat2'],
    'kay': ['prod2','personalized.','www', 'dev1','uat1', 'uat2'],
    'jared': ['prod2','personalized.','www', 'dev1','uat1', 'uat2'],
    'india': ['www'],
    'hsamuel': ['www'],
    'ejpersonalized': ['www'],
    'hspersonalized': ['www'],
};
let availableSitesUrl = {
    'localhost': DEFAULT_SITE + '.com',
    'zalesoutlet': 'zalesoutlet.com',
    'zales': 'zales.com',
    'gordonsjewelers': 'gordonsjewelers.com',
    'peoplesjewellers': 'peoplesjewellers.com',
    'pagoda': 'pagoda.com',
    'kayoutlet': 'kayoutlet.com',
    'kay': 'kay.com',
    'jared': 'jared.com',
    'india': 'ernestjones.co.uk',
    'hsamuel': 'hsamuel.co.uk',
    'ejpersonalized': 'ernestjones.co.uk',
    'hspersonalized': 'hsamuel.co.uk',
    
};


let availableSites = {
    'localhost': DEFAULT_SITE,
    'zalesoutlet': 'zalesoutlet',
    'zales': 'zales',
    'gordonsjewelers': 'gordonsjewelers',
    'peoplesjewellers': 'peoplesjewellers',
    'pagoda': 'pagoda',
    'kayoutlet': 'kayoutlet',
    'kay': 'kay',
    'jared': 'jared',
    'india': 'ernestjones',
    'hsamuel': 'hsamuel',
    'hspersonalized': 'hsamuel',
    'ejpersonalized': 'ernestjones',
    
};
let availableSitesList = [
    'localhost',
    'zalesoutlet',
    'zales',
    'gordonsjewelers',
    'peoplesjewellers',
    'pagoda',
    'kayoutlet',
    'kay',
    'jared',
    'ernestjones','india',
    'hsamuel',
    'hspersonalized',
    'ejpersonalized',
    
];

let siteNames = {
    'zales': 'Zales',
    'gordonsjewelers': 'Gordon\'s Jewelers',
    'peoplesjewellers': 'Peoples Jewellers',
    'zalesoutlet': 'Zales Outlet',
    'pagoda': 'Pagoda',
    'kay': 'Kay',
    'jared': 'Jared',
    'india': 'Ernest Jones',
    'hsamuel': 'H.Samuel',
    'sterlingjewelers': 'Sterling Jewelers',
    'kayoutlet': 'Kay Jewelers Outlet'
};

// let currentSites = {
//     prodzales: 'https://www.zales.com',
//     uat1zales: 'https://uat1.zales.com',
//     uat2zales: 'https://uat2.zales.com',
//     devzales: 'https://dev.zales.com',
//     prodkay1: 'https://www.kay.com',
//     devkay: 'https://dev.kay.com',
//     prodjared: 'https://www.jared.com',
//     devjared: 'https://dev.jared.com',
//     devernestjones: 'https://dev.ernestjones.co.uk',
//     prodernestjones: 'https://www.ernestjones.co.uk',
// };

var localhostSite =DEFAULT_SITE;

// window.currentSite = "ernestjones";
//window.currentSite = localhostSite;
window.currentEnv = "prod";
//window.currentSite = "kayoutlet";
// window.currentEnv = "test";
window.currentSite = DEFAULT_SITE;
//console.log('availableSites.keys', Object.keys(availableSites))
var all_sites = availableSitesList;
//console.log('all sites', all_sites);
for (let i in all_sites) {
    let val = all_sites[i];
    //console.log('try', val);
    if (window.location.href.includes(val)) {
        //console.log('set', val,window.location.href);
        window.currentSite = availableSites[val];
        break;
    }
}

//console.log('currentSite', window.currentSite);

var all_env = availableEnv[window.currentSite];
for (let i in all_env) {
    let val = all_env[i];
    if (window.location.href.includes(val)) {
        window.currentEnv = val;
        break;
    }
}
if (window.currentEnv === 'personalized.')
    window.currentEnv = 'www';
//console.log('temp currentEnv', window.currentEnv);

var calcUrl = window.currentEnv;
if (['zales', 'zalesoutlet', 'gordonsjewelers', 'peoplesjewellers', 'pagoda', 'kayoutlet','kay','jared'].indexOf(window.currentSite) !== -1 && calcUrl === 'personalized.') {
    calcUrl = 'www'
}
window.currentEnv =calcUrl;

// for localhost testing
if (['localhost'].indexOf(window.currentSite) !== -1 && calcUrl === 'localhost') {
    calcUrl = 'dev1';
    window.currentSite = localhostSite
}

window.currentSiteUrl = 'https://' + calcUrl + '.' + availableSitesUrl[window.currentSite];
//console.log('currentSiteUrl', window.currentSiteUrl);
window.baseSiteUrl = window.currentSiteUrl.replace('prod.', 'www.');
//console.log('baseSiteUrl', window.baseSiteUrl);

//console.log('currentEnv', window.currentEnv);

// default ..title
switch (window.currentSite) {
    case "zalesoutlet":
        document.title = 'Zales Outlet';
        break;
    case "ernestjones":
        document.title = 'Jewellery, Watches, Gifts - Ernest Jones';
        break;
    case "gordonsjewelers":
        document.title = "Gordon's Jewelers";
        break;
    case "peoplesjewellers":
        document.title = "Peoples Jewellers";
        break;
    case "pagoda":
        document.title = "Piercing Pagoda";
        break;
    case "sterlingjewelers":
        document.title = "Engagement Rings, Wedding Rings, Diamonds, Charms. Jewelry from SterlingJewelers Jewelers, your trusted Jewelry Store - SterlingJewelers";
        break;
    case "kay":
        document.title = "Engagement Rings, Wedding Rings, Diamonds, Charms. Jewelry from Kay Jewelers, your trusted Jewelry Store - Kay";
        break;
    case "kayoutlet":
        document.title = "Wedding Rings, Engagement Rings, Charms and more. Jewelry from KayOutlet Jewelers, your trusted Jewelry Store - KayOutlet";
        break;
    case "jared":
        document.title = "Wedding Rings, Watches, Diamonds and more. Jared&reg; the Galleria of Jewelry, 5X the selection of Ordinary Jewelry Stores - Jared";
        break;
    default:
        document.title = window.currentSite.charAt(0).toUpperCase() + window.currentSite.substr(1);
        break;
}


window.siteName = siteNames[window.currentSite];

// import css
switch (window.currentSite) {
    case "localhost":
        import('./site_interfaces/'+ localhostSite +'.css');
        break;
    default:
        import('./site_interfaces/' + window.currentSite + '.css');
        break;
}
}


// WEBPACK FOOTER //
// ./src/header_footer_parameters.js